

import { Component, Inject, OnInit, Optional, Input, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// Ask this --> about material module on importing
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { SharedApiService } from '../../services/shared-api.service';
import lifeProductType from '../../life-config/productCodeConfig.json';
import apiUrlPoint from '../../life-config/apiEndPoints.json';
import { DialogData } from '../../model/data.model';

@Component({
    selector: 'app-bqp-otp',
    templateUrl: './bqp-otp.component.html',
    styleUrls: ['./bqp-otp.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class BQPOtpComponent implements OnInit {

    OTPValidation: FormGroup;
    uuid: string;
    proposalId: string;

    apiUrl: object = apiUrlPoint.apiEndPoints;
    productType: object = lifeProductType.componentClassName;
    editModalConfData: object;
    inputValueFromCmp: number | string;
    calValFromCmp: object;
    annualIncomeInComma: any;
    numberInWords: any;
    annualIncomeData: any;
    sumAssuredValue: any;
    policyList: any = [];
    initialBQPMessage: string;
    hideIRDAIMsg = false;
    otpInitiateBQPMessage: string;
    isLoaderActivated = false;
    bqpEmailRes: any;

    // Unable to add private class
    otpModalRes: any;
    destroySubject$: Subject<void> = new Subject();

    constructor(
        private dialogRef: MatDialogRef<BQPOtpComponent>,
        private formbuild: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private apiService: ApiService,
        private sharedData: SharedApiService,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) {

        this.uuid = data['uuid'];
        this.proposalId = data['proposalId'];
        this.initialBQPMessage = data['editQuoteInfo']['life_bqp']['message'];
        this.otpInitiateBQPMessage = data['editQuoteInfo']['life_bqp']['otp_message'];


        this.OTPValidation = this.formbuild.group({

        custOTP: ['',
            [Validators.required, Validators.minLength(1), Validators.maxLength(6), Validators.pattern(new RegExp('^[0-9]*$'))]],

        });

        this.apiService.getStatusEvent.subscribe(value => {

        if (value) {
            const errorStatusFromApi = value['status'];

            if ( errorStatusFromApi === 400 ) {

                /**
                 * Trigger Email if it has been failed
                 */

                this.hideIRDAIMsg = false;
                this.isLoaderActivated = false;
            }
        }


        });


    }

    triggerEmail() {

        /**
         * currenlty email is triggering to BQP only
         * customer will have different form of BI
         */
        const evntType = {
            event_type: 'v1'
        };
        this.apiService.postWithData(

            this.apiUrl['apiV2LifeProposal'], this.proposalId, this.uuid, this.apiUrl['shareBIOnEmail'], evntType)
            .subscribe(shareEmailres => {

                if (shareEmailres) {
                    this.bqpEmailRes = shareEmailres;
                    this.hideIRDAIMsg = false;
                }
            });
    }

    ngOnInit() {
        this.triggerEmail();
    }




    verifyOTP(isValid: boolean, event) {

        if (isValid) {

            this.isLoaderActivated = true;
            const data = {
            otp_type: 3,
            otp_token: this.OTPValidation.get('custOTP').value
        };

            this.apiService.postWithData(

            this.apiUrl['apiV2LifeProposal'], this.proposalId, this.uuid, this.apiUrl['VerifyOTP'], data).subscribe(res => {

            if (res) {


                this.dialogRef.close({ event: 'close', data: true });

            }


            });

        }


    }

    initateOTP() {

        // this.router.navigate(['/life/payment-failure', this.proposalId, this.uuid]);
        // Add it into config
        const data = {
            otp_type: 3,
        };

        this.apiService.postWithData(
            this.apiUrl['apiV2LifeProposal'], this.proposalId, this.uuid, this.apiUrl['sendOTP'], data).subscribe(otpRes => {

                if (otpRes) {

                    const otpres = otpRes;
                }


        });


    }


    cancelOTP() {
        this.dialogRef.close();
    }


    /**
     * Proceed to open OTP window
     */

    proceedToOTP() {

        /**
         * case 1-> api res is success will trigger otp modal
         * case 2-> no api res will display bqp modal
         */

        if (this.bqpEmailRes) {
            this.hideIRDAIMsg = true;
            this.initateOTP();
        } else {
            this.triggerEmail();
        }

    }

}
